import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { SAVE_STORE_CHANGED, APP_LEAVING } from '../../constants/ActionTypes';

import CTModal from '../helpers/CTModal';

class ModalThemeAndConfigHelp extends Component {
    constructor(props) {
        super(props);
        this.onClose = this.onClose.bind(this);
        this.state = {};
    }

    onClose() {
        this.props.close();
    }

    render() {
        return (
            <CTModal
                open={this.props.open}
                primaryButtonTitle="Ok"
                primaryButton={true}
                primaryButtonClick={this.onClose}
                onClose={this.onClose}
            >
                <div className="spark-message spark-message--lg spark-message--info spark-panel">
                    <div className="spark-panel__content">
                        <i className="spark-message__icon spark-icon-note spark-icon--fill" />
                        <div className="spark-message__content">
                            <h4 className="spark-message__heading">Help for the selection of Theme and Config</h4>
                            <p>Call HS Helpdesk</p>
                            <p>or follow these steps:</p>
                            <ul>
                                <li>Select A</li>
                                <li>Select B</li>
                                <li>Select C</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </CTModal>
        );
    }
}

ModalThemeAndConfigHelp.defaultProps = {
    open: false
};

ModalThemeAndConfigHelp.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired
};

/**
 STORE stuff. See store/AppStore.js
*/

export const SHOW_MODAL_THEME_AND_CONFIG_HELP = 'SHOW_MODAL_THEME_AND_CONFIG_HELP';
export const HIDE_MODAL_THEME_AND_CONFIG_HELP = 'HIDE_MODAL_THEME_AND_CONFIG_HELP';

const initialState = {
    isOpened: false
};

export const modalThemeAndConfigHelpReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_MODAL_THEME_AND_CONFIG_HELP:
            return {
                isOpened: true
            };
        case HIDE_MODAL_THEME_AND_CONFIG_HELP:
        case APP_LEAVING:
            return {
                isOpened: false
            };
        default:
            return state;
    }
};

export const modalThemeAndConfigHelpActions = {
    show() {
        return dispatch => {
            dispatch({ type: SHOW_MODAL_THEME_AND_CONFIG_HELP });
        };
    },
    hide() {
        return dispatch => {
            dispatch({ type: HIDE_MODAL_THEME_AND_CONFIG_HELP });
        };
    }
};

/**
 /STORE stuff. See store/AppStore.js
*/

const mapStateToProps = state => {
    return {
        open: state.app.modal.themeAndConfigHelp.isOpened
    };
};

const mapDispatchToProps = dispatch => ({
    close: () => dispatch(modalThemeAndConfigHelpActions.hide())
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalThemeAndConfigHelp);



// WEBPACK FOOTER //
// ./src/components/modals/ModalThemeAndConfigHelp.js